import { render } from "./EditInscriptionView.vue?vue&type=template&id=110a770d"
import script from "./EditInscriptionView.vue?vue&type=script&lang=js"
export * from "./EditInscriptionView.vue?vue&type=script&lang=js"

import "./EditInscriptionView.vue?vue&type=style&index=0&id=110a770d&lang=scss"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__